import LBox from "@components/LBox";
import { FC } from "react";
import { PropsWithChildren } from "react";
import { theme } from "@theme";
import { Platform } from "react-native";

type InnerBorderCardProps = PropsWithChildren<{
  width: number;
  height: number;
  borderRadius?: keyof typeof theme.borderRadii;
  variant?: "default" | "special" | "specialUnlocked";
}>;

const InnerBorderCard: FC<InnerBorderCardProps> = ({
  children,
  width,
  height,
  borderRadius,
  variant = "default",
}) => {
  return (
    <LBox
      overflow="hidden"
      width={width}
      height={height}
      borderRadius={borderRadius}
      alignItems="center"
    >
      {variant === "default" ? (
        <>
          <LBox
            width={width}
            height={height}
            borderRadius={borderRadius}
            borderWidth={1}
            borderColor="whiteBorder"
            // on web, we need to set the alignItems and justifyContent to undefined to fill the container, otherwise the image doesn't show
            alignItems={Platform.OS === "web" ? undefined : "center"}
            justifyContent={Platform.OS === "web" ? undefined : "center"}
          >
            {children}
          </LBox>
        </>
      ) : null}
      {variant === "special" ? (
        <LBox
          width={width}
          height={height}
          borderRadius={borderRadius}
          backgroundColor={["privateContentTop", "privateContentBottom"]}
          alignItems="center"
          justifyContent="center"
        >
          {children}
        </LBox>
      ) : null}
      {variant === "specialUnlocked" ? (
        <LBox
          width={width}
          height={height}
          borderRadius={borderRadius}
          backgroundColor={[
            "privateContentUnlockedTop",
            "privateContentUnlockedBottom",
          ]}
          alignItems="center"
          justifyContent="center"
        >
          {children}
        </LBox>
      ) : null}
    </LBox>
  );
};

export default InnerBorderCard;
